export default "__VITE_ASSET__B6GSKAXc__"